import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import ReactPlayer from "react-player";



function Rupaecobrick() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray"/>
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Rupa Eco Brick</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 style={{ color: "#736f6fff" }} className='misaa'>  Honorable Debapriya Gope, owner of RUPA ECO BRICK ) gave a very good review to Tanmay Sarkar ( MR. INDIAN CODER ) |
                                </h1>
                                <p>Read more about RUPA ECO BRICK and their products. visit the official website: <a href='https://www.rupaecobrick.com/' target="_blank" rel="noopener noreferrer"> https://www.rupaecobrick.com/</a></p>
                                <p className='websitedevelopment mb-2' style={{ color: "grey" }}>Rupa Eco Brick stands as one of the most trusted names in Berhampore, Murshidabad, specializing in the manufacturing and supply of high-quality Paver Blocks, Tiles, and Bricks.</p>
                             
                            </div>
                            <div className="col-md-5">
                                                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=2INN8eQNLpM" />
                                                                        
                            
                            </div>
                               <p className='websitedevelopment' style={{ color: "grey" }}><small>It gives me immense pride to share that the very first website I developed in Berhampore was for Rupa Eco Brick. Our first meeting took place in 2023 at their factory located in Mankara, Balarampur- Berhampore. There, I had the pleasure of meeting Respected Mr. Debapriya Gope, a gentleman of remarkable humility and vision. He shared his ideas and expectations for the website in detail, and with his guidance, I began the development work.</small></p>
                                 <p className='websitedevelopment' style={{ color: "grey" }}><small>Within just 1–2 months, the website was successfully launched. Now, in August 2025, I am delighted to see that their digital presence continues to operate seamlessly, reflecting the same commitment to quality as their products.</small></p>
                                 <p>Working with Hon'ble Debapriya Gope has been a truly enriching experience. I have personally visited the Rupa Eco Brick factory several times, and each visit has been met with outstanding hospitality. The cordial behavior of Hon'ble Debapriya Gope and his entire team speaks volumes about their professionalism and values</p>
                        </div>
                        <br />
                        <h6 className='websitedevelopment mb-2' style={{ color: "grey" }}>I was deeply honored to receive an exceptional review from Hon'ble Debapriya Gope himself—a gesture I will always treasure.</h6>

      

                        <br />
                        <h6><b>Team MR. INDIAN CODER</b></h6>
                    </div>
                </div>

                <br />

            </div>


        </div>
    )
}

export default Rupaecobrick